'use client';

import { getBlogSearch } from '@/utils/blog/getBlogSearch';
import Link from 'next/link';
import React, { useCallback, useEffect, useRef, useState } from 'react';

const BlogSearch = ({ search }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [timeoutId, setTimeoutId] = useState(null);
  const inputRef = useRef(null);
  const [query, setQuery] = useState('');

  const fetchSuggestions = useCallback(
    async (productName) => {
      try {
        const data = await getBlogSearch(productName);
        setSuggestions(data);
      } catch (err) {
        console.log(err);
      }
    },
    [setSuggestions]
  );

  useEffect(() => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    const id = setTimeout(() => {
      if (query.length > 0) {
        fetchSuggestions(query);
      }
    }, 300);
    setTimeoutId(id);
  }, [query, fetchSuggestions]);
  return (
    <div
      className={`relative min-w-[250px] ${
        search ? 'block' : ' md:hidden block'
      }`}
    >
      <div
        className={`border-2 bg-white border-black text-black flex items-center gap-0 pr-3 py-3 rounded-3xl`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="black"
          viewBox="0 0 256 256"
          className="ml-4 mr-3 cursor-pointer"
        >
          <path d="M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"></path>
        </svg>
        <input
          ref={inputRef}
          type="text"
          placeholder="Search Articles"
          className="bg-transparent w-full md:text-sm text-[17px] placeholder:text-[12px] font-proxima_font placeholder:text-black placeholder:font-semibold outline-none "
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>
      <div
        className={`${
          query?.length !== 0 ? 'flex' : 'hidden'
        } flex-col w-full max-h-[50vh] p-5 overflow-y-auto absolute bg-white border-slate-200 border z-50 top-14 rounded-xl no-scrollbar`}
      >
        <p className={`text-black text-lg font-bold `}>
          {suggestions && suggestions?.length !== 0
            ? 'Suggestions'
            : 'No Suggestions'}
        </p>
        {suggestions?.map((blog, index) => {
          return (
            <Link
              key={index}
              href={blog?.redirect_url ?? `/blog/${blog?.slug}`}
              target={blog?.redirect_url ? '_blank' : '_self'}
            >
              <p
                className={`cursor-pointer text-black font-medium py-2 hover:underline text-[16px] font-proxima-font transition-all duration-300`}
              >
                {blog?.name}
              </p>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default BlogSearch;
